import { getMarkerFont } from '../components/canvas/utils/get-marker-font.js';

export const buildCanvasForTextMeasuring = () => {
  const canvasContext =
    document.createElement('canvas').getContext('2d') ??
    new CanvasRenderingContext2D();

  canvasContext.font = getMarkerFont();

  return canvasContext;
};
